export default __webpack_public_path__ + "static/media/opensans-400.029b9bc9.ttf";